import { render, staticRenderFns } from "./Accept.html?vue&type=template&id=dcfcc324&"
import script from "./Accept.js?vue&type=script&lang=js&"
export * from "./Accept.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports